import { render, staticRenderFns } from "./BusinessConsulting2.vue?vue&type=template&id=2fb4a0d9&"
import script from "./BusinessConsulting2.vue?vue&type=script&lang=js&"
export * from "./BusinessConsulting2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports